import { useCallback } from 'react';

import { useDispatch } from 'react-redux';

import type { ShowToastPayload } from 'modules/ui';
import { hideSpinner, showAlarm, showSpinner, uiActions } from 'modules/ui';

export default function useUIActions() {
  const dispatch = useDispatch();

  return {
    showSpinner: useCallback(() => dispatch(showSpinner()), [dispatch]),
    hideSpinner: useCallback(() => dispatch(hideSpinner()), [dispatch]),
    showAlarm: useCallback((alarm: string) => dispatch(showAlarm(alarm)), [dispatch]),
    showToast: useCallback((payload: ShowToastPayload) => dispatch(uiActions.showToast(payload)), [dispatch]),
    hideToast: useCallback((id: string) => dispatch(uiActions.hideToast({ id })), [dispatch]),
  };
}
